<!--
  Tool-Tip Component

  @since 2018-04-19
  @author kdydesign.kim
-->

<template>
  <q-tooltip :anchor="getPosition.anchor"
             :self="getPosition.self"
             :offset="[10, 10]"
             :delay="500"
             class="bs bs-q-tooltip bs-q-tooltip-default"
             style="textOverflow: 'ellipsis'">
    <slot>
      {{message}}

      <div v-for="msg in validMsg">
        <span>{{msg}}</span>
      </div>
    </slot>
  </q-tooltip>
</template>

<script>
  export default {
    name: 'ToolTip',
    props: {
      position: {
        type: String,
        default: 'top'
      },
      message: {
        type: String,
        default: ''
      },
      maxValue: {
        type: [Number, String],
        default: void 0
      },
      defaultValue: {
        type: [Number, String],
        default: void 0
      },
      minValue: {
        type: [Number, String],
        default: void 0
      },
      maxLength: {
        type: [Number, String],
        default: void 0
      },
      minLength: {
        type: [Number, String],
        default: void 0
      }
    },
    data () {
      return {
        validMsg: [],
        maxValueMsg: this.$t('cmn.maxValue', { val: this.getSeparateByComma(this.maxValue) }),
        minValueMsg: this.$t('cmn.minValue', { val: this.getSeparateByComma(this.minValue) }),
        defaultValueMsg: this.$t('cmn.defaultValue', { val: this.getSeparateByComma(this.defaultValue) }),
        maxLengthMsg: this.$t('cmn.maxLength', {val: this.maxLength}),
        minLengthMsg: this.$t('cmn.minLength', {val: this.minLength})
      }
    },
    computed: {
      getPosition () {
        const position = this.position
        let resultPos = null

        switch (position) {
          case 'top' :
            resultPos = {
              anchor: 'top middle',
              self: 'bottom middle'
            }
            break
          case 'left' :
            resultPos = {
              anchor: 'center left',
              self: 'center right'
            }
            break
          case 'right' :
            resultPos = {
              anchor: 'center right',
              self: 'center left'
            }
            break
          case 'bottom' :
            resultPos = {
              anchor: 'bottom middle',
              self: 'top middle'
            }
            break
          default:
            resultPos = null
        }

        return resultPos
      }
    },
    created () {
      this.setMessage()
    },
    methods: {
      setMessage () {
        this.validMsg = []

        const prop = _.keysIn(this.$options.propsData)
        for (let key of prop) {
          if (this[key] !== void 0) {
            this.validMsg.push(this[`${key}Msg`])
          }
        }
      },
      /**
       * 이름: getSeparateByComma
       * 설명: 전달된 값에 3자리마다 콤마를 추가한다.
       */
      getSeparateByComma (x) {
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0
      }
    },
    watch: {
      maxValue () {
        this.maxValueMsg = this.$t('cmn.maxValue', { val: this.getSeparateByComma(this.maxValue) })
        this.setMessage()
      },
      minValue () {
        this.minValueMsg = this.$t('cmn.minValue', { val: this.getSeparateByComma(this.minValue) })
        this.setMessage()
      },
      defaultValue () {
        this.defaultValueMsg = this.$t('cmn.defaultValue', { val: this.getSeparateByComma(this.defaultValue) })
        this.setMessage()
      },
      maxLength () {
        this.maxLengthMsg = this.$t('cmn.maxLength', {val: this.maxLength})
        this.setMessage()
      },
      minLength () {
        this.minLengthMsg = this.$t('cmn.minLength', {val: this.minLength})
        this.setMessage()
      }
    }
  }
</script>
